const navigationGlobal = {
  config: {
    general: {
      textColor: {
        label: "Default Black",
        value: "#161616",
      },
      backgroundColor: {
        label: "Default White",
        value: "#ffffff",
      },
      hoverColor: {
        label: "Custom 2",
        value: "#1CD66A",
      },
      navigationBarSize: {
        label: "Small",
        value: "small",
      },
      links: [
        {
          label: "Group 1",
          links: [
            {
              label: "Group 1 Some Long Link 1",
              url: "https://www.example.com",
            },
            {
              label: "Group 1 Link 2",
              url: "https://www.example.com",
            },
          ],
        },
        {
          label: "Link 2",
          url: "https://www.example.com",
          links: null,
        },
        {
          label: "Group 2",
          links: [
            {
              label: "Group 2 Link 1",
              url: "https://www.example.com",
            },
            {
              label: "Group 2 Link 2",
              url: "https://www.example.com",
            },
          ],
        },
        {
          label: "Link 4",
          url: "https://www.example.com",
          links: null,
        },
        {
          label: "Group 3",
          links: [
            {
              label: "Group 3 Link 1",
              url: "https://www.example.com",
            },
            {
              label: "Group 3 Link 2",
              url: "https://www.example.com",
            },
            {
              label: "Group 3 Link 3",
              url: "https://www.example.com",
            },
          ],
        },
      ],
      languages: [
        {
          details: {
            label: "English",
            locale: "en-EN",
          },
          url: "https://www.example.com/en",
        },
        {
          details: {
            label: "German formal",
            locale: "de-DE_formal",
          },
          url: "https://www.example.com/de-formal",
        },
        {
          details: {
            label: "German",
            locale: "de-DE",
          },
          url: "https://www.example.com/de",
        },
        {
          details: {
            label: "French",
            locale: "fr-FR",
          },
          url: "https://www.example.com/fr",
        },
      ],
    },
    ctaButton: {
      text: "All jobs",
      url: "https://www.example.com/whatever",
      textColor: {
        label: "Default Black",
        value: "#161616",
      },
      backgroundColor: {
        label: "Light Grey",
        value: "#DBDBDB",
      },
      fillStyle: {
        label: "Fill",
        value: "fill",
      },
      corners: {
        label: "Round",
        value: "round",
      },
    },
  },
};

export default navigationGlobal;
